import Link from "next/link";

const SOCIALS = [
  { label: "X / Twitter", href: "https://x.com/gerawrdog" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/gerawrdog" },
  { label: "Instagram", href: "https://instagram.com/gerawrdog" },
  { label: "Cursor", href: "https://cursor.com/@ger" },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden border-t border-[var(--style-border)] bg-[var(--style-bg-soft)]">
      <div className="relative mx-auto max-w-6xl px-5 py-20 md:px-6 md:py-28">
        <p className="section-eyebrow mb-6">That&apos;s the tour</p>
        <p className="font-display text-4xl font-semibold tracking-tight text-style-heading sm:text-5xl md:text-7xl">
          Say <span className="serif-accent gradient-text">hi</span> sometime.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
          {SOCIALS.map((social) => (
            <Link
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs uppercase tracking-[0.2em] text-style-muted underline decoration-[var(--style-accent)]/40 underline-offset-8 transition-colors hover:text-style-accent"
            >
              {social.label}
            </Link>
          ))}
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-[var(--style-border)] pt-8 sm:flex-row sm:items-center sm:justify-between md:mt-20">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-style-faint">
            {year} © Gerardo Gutierrez
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-style-faint">
            Built by me — in Cursor, naturally ✦
          </p>
        </div>
      </div>
    </footer>
  );
}
